import React, { useEffect, useState } from 'react';
import { Button } from './ui/button';
import { apiService, MemoryPhoto } from '../services/api';
import { useScrollReveal } from '../lib/useScrollReveal';

/** Menos que isso deixa a faixa pela metade e parece defeito. */
const MINIMUM_PHOTOS = 3;
const STRIP_LIMIT = 5;

export function MemoriesSection() {
  const headingReveal = useScrollReveal<HTMLDivElement>();
  const [photos, setPhotos] = useState<MemoryPhoto[]>([]);
  const [failed, setFailed] = useState(false);
  const [isRetrying, setIsRetrying] = useState(false);

  const loadMemories = async () => {
    try {
      const response = await apiService.getRecentMemories(STRIP_LIMIT);
      setPhotos(response.photos);
      setFailed(false);
    } catch {
      setPhotos([]);
      setFailed(true);
    } finally {
      setIsRetrying(false);
    }
  };

  useEffect(() => {
    void loadMemories();
  }, []);

  const handleRetry = async () => {
    setIsRetrying(true);
    await loadMemories();
  };

  // Enquanto carrega, a home nao mostra esqueleto: a section so aparece quando
  // ha fotos de verdade, e some sozinha quando o album volta a rascunho.
  if (!failed && photos.length < MINIMUM_PHOTOS) {
    return null;
  }

  // O ultimo lugar da faixa e sempre o convite, nunca um contador.
  const tiles = photos.slice(0, STRIP_LIMIT - 1);
  // O indice de albuns ainda nao existe, entao o convite leva ao album mais recente.
  const albumUrl = photos.length > 0 ? photos[0].eventUrl : '';

  return (
    <section className="home-memories" aria-labelledby="home-memories-title">
      <div className="container-modern home-memories__inner">
        <div {...headingReveal} className="home-memories__heading">
          <p className="home-memories__kicker">Memórias</p>
          <h2 id="home-memories-title">Você estava lá?</h2>
          <p className="home-memories__sub">Fotos dos eventos que já rolaram. Ache a sua e compartilhe.</p>
        </div>
        {albumUrl !== '' && !failed && (
          <a className="home-memories__cta" href={albumUrl}>Ver todas as fotos</a>
        )}

        {failed ? (
          <div className="home-memories__error">
            <p>Não foi possível carregar as fotos.</p>
            <Button onClick={handleRetry} disabled={isRetrying} className="btn-modern btn-primary-modern">
              {isRetrying ? 'Tentando...' : 'Tentar Novamente'}
            </Button>
          </div>
        ) : (
          <div className="home-memories__strip" data-count={tiles.length + 1}>
            {tiles.map((photo, index) => (
              <a key={photo.id} className="memory-tile" href={photo.eventUrl}>
                <img
                  className="memory-tile__image"
                  src={photo.photoUrl}
                  alt={`Foto de ${photo.eventName}${photo.location ? ` em ${photo.location}` : ''}${photo.dateLabel ? `, ${photo.dateLabel}` : ''}`}
                  width={photo.width || undefined}
                  height={photo.height || undefined}
                  loading={index < 2 ? 'eager' : 'lazy'}
                  decoding="async"
                />
              </a>
            ))}
            <a className="memory-tile memory-tile--more" href={albumUrl}>
              <span>Ver todas as fotos</span>
            </a>
          </div>
        )}
      </div>
    </section>
  );
}
